export default {
  border: true,
  roundedTop: '@theme:card.rounded',
  fontSize: '3',
  fontWeight: 'bold',
  textColor: 'white',
  height: '100',
  style: { backgroundColor: 'rgba(0, 0, 0, 0.15)' },
  showJourneyType: false,
  showDurationTrip: false,
  showTravelClass: false,
  showPill: false,
  showLastSeen: false,
  showPrice: false,
  showDepartureInfo: false,
  showReturnInfo: false,
  fareBodyItem: {
    padding: '13px',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100',
  },
  fareItemBackgroundImage: {
    roundedTop: '@theme:card.rounded',
    imageHeight: '320px',
    focusable: false,
  },
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showOriginLabel: true,
    showDestinationLabel: true,
    showSeparator: false,
    showLineSeparator: true,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '3',
    textTransform: 'uppercase',
    originLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
    destinationStyles: {
      fontSize: '6',
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
  },
};
